module.exports = __webpack_public_path__ + "static/media/teo-logo-bigv2.4b11865e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/teo-logo-bigv2.png
// module id = 1862
// module chunks = 0